module.exports = __webpack_public_path__ + "static/media/days-icon.ed186c58.svg";